import React from 'react';
import { motion } from 'framer-motion';
export function ProductImage() {
  return <div className="py-16 px-4 sm:px-6 bg-gradient-to-b from-white to-mint-50" data-id="element-174">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto" data-id="element-175">
        <img src="https://cdn.magicpatterns.com/uploads/kS7cUZn7dVYbbq3LNSkwaD/heylloyd-image-1769381975639.png" alt="Dormir Sin Pensar - Protocolo 14 Noches para Apagar la Mente" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-176" />
      </motion.div>
    </div>;
}